module.exports = {
      id: "comm-spiritual-usage",
      viewBox: "0 0 271.278 58.643",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-spiritual",
      toString: function () {
        return this.url;
      }
    }